export class Color {
    constructor (
        public r: number,
        public g: number,
        public b: number) {        
    }
}